import React, { useEffect, useState } from 'react';
import apiService from '../services/api';

// 简约移动端风格
const WxHome = () => {
  const [user, setUser] = useState(null);
  const [points, setPoints] = useState([]);
  const [totalPoints, setTotalPoints] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    console.log('[WxHome] 页面加载时token:', token);
    console.log('[WxHome] useEffect triggered. token =', token);

    // 防止无token死循环
    if (!token) {
      if (sessionStorage.getItem('justRedirected')) {
        console.warn('[WxHome] Preventing infinite redirect loop (no token).');
        return;
      }
      sessionStorage.setItem('justRedirected', '1');
      console.warn('[WxHome] No token found, redirecting to /wx/entry');
      window.location.href = '/wx/entry';
      return;
    }
    sessionStorage.removeItem('justRedirected');

    // 401 死循环防抖
    if (sessionStorage.getItem('authFailedOnce')) {
      console.error('[WxHome] 401 detected previously, not redirecting again.');
      setLoading(false);
      setUser({error: '认证失败，请重新登录或联系管理员。', token});
      return;
    }

    console.log('[WxHome] Start fetching user and points info...');
    Promise.all([
      apiService.getCurrentUser(),
      apiService.getUserPoints()
    ]).then(([userRes, pointsRes]) => {
      console.log('[WxHome] getCurrentUser response:', userRes);
      console.log('[WxHome] getUserPoints response:', pointsRes);
      setUser(userRes.data);
      setPoints(pointsRes.data.points || []);
      setTotalPoints(pointsRes.data.total_points ?? 0);
    }).catch(err => {
      console.error('[WxHome] Error during data fetch:', err);
      // 401（未认证）或404（用户不存在）都强制清理token并跳转
      if (err.response && (err.response.status === 401 || err.response.status === 404)) {
        if (sessionStorage.getItem('authFailedOnce')) {
          setUser({error: '认证失败或用户不存在，请重新登录。', token});
          setLoading(false);
          return;
        }
        sessionStorage.setItem('authFailedOnce', '1');
        console.warn('[WxHome] 认证失败或用户已被删除，清除token并跳转。');
        localStorage.removeItem('token');
        window.location.href = '/wx/entry';
      }
    }).finally(() => {
      console.log('[WxHome] Loading finished.');
      setLoading(false);
    });
  }, []);

  if (loading) return <div style={{textAlign:'center',marginTop:'30vh'}}>加载中…</div>;
  if (user && user.error) {
    return (
      <div style={{color:'red',padding:16}}>
        {user.error}<br />
        当前token: <pre style={{wordBreak:'break-all'}}>{user.token}</pre>
      </div>
    );
  }
  if (!user) return null;

  return (
    <div style={{padding:16,maxWidth:400,margin:'0 auto',fontFamily:'-apple-system,BlinkMacSystemFont,Segoe UI'}}>
      <h2 style={{textAlign:'center'}}>GHPT 积分中心</h2>
      <div style={{background:'#f7f7f7',borderRadius:8,padding:12,marginBottom:16}}>
        <div>昵称：{user.nickname || user.username}</div>
        <div>电话：{user.phone || '-'}</div>
        <div>总积分：{totalPoints}</div>
      </div>
      <h4>积分明细</h4>
      <ul style={{listStyle:'none',padding:0}}>
        {points.length === 0 && <li>暂无积分记录</li>}
        {points.map((p,i) => (
          <li key={i} style={{borderBottom:'1px solid #eee',padding:'8px 0'}}>
            <div>活动：{p.activity?.name || p.activity_name || '-'}</div>
            <div>积分：{p.points}</div>
            <div style={{fontSize:12,color:'#888'}}>{p.awarded_at}</div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default WxHome;
